import {gsap} from 'gsap';

const headerInit = () => {
  const tl = gsap.timeline({id: 'header'});

  if (!document.querySelector('[data-element="right-segment"]')) {
    tl.from(
      '[data-element="top-shape"]',
      {
        autoAlpha: 0,
        delay: 0.3,
        duration: 0.5,
        y: '-100%',
      }
    ).from(
      '[data-element="header-text"]',
      {
        autoAlpha: 0,
        y: '-16',
      }
    );
  } else {
    tl.from(
      '[data-element="top-shape"]',
      {
        autoAlpha: 0,
        delay: 0.3,
        duration: 0.5,
        y: '-100%',
      }
    ).from(
      '[data-element="right-segment"]',
      {
        autoAlpha: 0,
        duration: 0.5,
        y: '50%',
      },
      '<'
    ).from(
      '[data-element="header-text"]',
      {
        autoAlpha: 0,
        y: '-16',
      }
    );
  }
};

const headerAnimations = {
  init() {
    const header = document.querySelector('[data-module="header-shapes"]');

    if (header) {
      headerInit();
    }
  },
};

export default headerAnimations;
